<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ handleSubmit, errors }">
    <form
      class="body-measurements-form"
      @submit.prevent="handleSubmit(onSubmit)">
      <BaseSelectGroupWithProvider
        v-model="form.gradeCode"
        name="学年を選択"
        label="学年を選択"
        :options="gradeOptions"
        rules="required"
        test-id="grade-code-select"
        vid="gradeCode" />

      <div
        class="border mb-2"
        data-testid="height-input-section">
        <label>身長</label>
        <div>
          <b-row class="table-row mx-0">
            <b-col
              v-for="(bodyMeasurement1, index) in form.bodyMeasurements"
              :key="index"
              cols="2"
              class="table-cell">
              <label class="py-1 mb-0">{{ bodyMeasurement1.month }}月</label>
              <BaseTextFieldWithProvider
                v-model="form.bodyMeasurements[index].height"
                name="身長"
                :vid="`height_${bodyMeasurement1.month}`"
                field-class="text-center"
                empty-str-to-null
                inputmode="decimal"
                rules="decimal:1"
                hide-error-message />
            </b-col>
          </b-row>
          <BaseErrorMessage
            v-for="key in Object.keys(errors).filter(key => key.startsWith('height_'))"
            :key="key"
            :errors="errors[key]" />
        </div>
      </div>

      <div class="border mb-2">
        <label>体重</label>
        <div>
          <b-row class="table-row mx-0">
            <b-col
              v-for="(bodyMeasurement2, index) in form.bodyMeasurements"
              :key="index"
              cols="2"
              class="table-cell">
              <label class="py-1 mb-0">{{ bodyMeasurement2.month }}月</label>
              <BaseTextFieldWithProvider
                v-model="form.bodyMeasurements[index].weight"
                name="体重"
                :vid="`weight_${bodyMeasurement2.month}`"
                field-class="text-center"
                empty-str-to-null
                inputmode="decimal"
                rules="decimal:1"
                hide-error-message />
            </b-col>
          </b-row>
          <BaseErrorMessage
            v-for="key in Object.keys(errors).filter(key => key.startsWith('weight_'))"
            :key="key"
            :errors="errors[key]" />
        </div>
      </div>
      <div
        class="d-flex justify-content-between mt-8"
        style="gap: 16px;">
        <button
          type="button"
          class="btn btn-block btn-cancel"
          @click="onClickCancel">
          キャンセル
        </button>
        <button
          type="submit"
          class="btn btn-block btn-primary mt-0">
          保存
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import BaseSelectGroupWithProvider from '@/components/parts/BaseSelectGroupWithProvider.vue'
import BaseTextFieldWithProvider from '@/components/parts/BaseTextFieldWithProvider.vue'
import BaseErrorMessage from '@/components/parts/BaseErrorMessage.vue'
import { bodyMeasurementGradeCodeOptions } from '@/helper/profile'
export default {
  components: {
    BaseSelectGroupWithProvider,
    BaseTextFieldWithProvider,
    BaseErrorMessage
  },
  props: {
    bodyMeasurement: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        gradeCode: null,
        bodyMeasurements: [
          {
            month: 4,
            height: '',
            weight: '',
          },
          {
            month: 5,
            height: '',
            weight: '',
          },
          {
            month: 6,
            height: '',
            weight: '',
          },
          {
            month: 7,
            height: '',
            weight: '',
          },
          {
            month: 8,
            height: '',
            weight: '',
          },
          {
            month: 9,
            height: '',
            weight: '',
          },
          {
            month: 10,
            height: '',
            weight: '',
          },
          {
            month: 11,
            height: '',
            weight: '',
          },
          {
            month: 12,
            height: '',
            weight: '',
          },
          {
            month: 1,
            height: '',
            weight: '',
          },
          {
            month: 2,
            height: '',
            weight: '',
          },
          {
            month: 3,
            height: '',
            weight: '',
          },
        ]
      },
    }
  },
  computed: {
    gradeOptions() {
      return bodyMeasurementGradeCodeOptions
    }
  },
  created() {
    this.setBodyMeasurement()
  },
  methods: {
    onSubmit() {
      const form = {
        gradeCode: this.form.gradeCode,
        bodyMeasurements: this.form.bodyMeasurements.filter(bodyMeasurement => {
          return bodyMeasurement.height !== '' || bodyMeasurement.weight !== ''
        })
      }
      this.$emit('submit', form)
    },
    setBodyMeasurement() {
      if (this.bodyMeasurement) {
        this.form = {
          gradeCode: this.bodyMeasurement.gradeCode,
          bodyMeasurements: this.form.bodyMeasurements.map(bodyMeasurement => {
            const monthlyData = this.bodyMeasurement.bodyMeasurements.find(data => data.month === bodyMeasurement.month)
            if (!monthlyData) {
              return bodyMeasurement
            }
            return {
              month: monthlyData.month,
              height: monthlyData.height,
              weight: monthlyData.weight,
            }
          })
        }
      }
    },
    onClickCancel() {
      this.$router.back()
    }
  },
}
</script>

<style lang="scss" scoped>
.table-row {
  display: flex;
  align-items: center;
}

.table-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;

  // cellに枠線をつける
  &:after {
    position: absolute;
    box-sizing: border-box;
    top: -0.5px;
    left: -0.5px;
    content: '';
    width: calc(100% + 1px);
    height: calc(100% + 1px);
    border: 1px solid $grey11;
    pointer-events: none;
  }
}

</style>